import PersonBase from './base/PersonBase';

/**
 * @class Person
 * @extends PersonBase
 */
class Person extends PersonBase {

}

export default Person;
